import { render, staticRenderFns } from "./ProfilePublicPages.vue?vue&type=template&id=3b1c0412&"
import script from "./ProfilePublicPages.vue?vue&type=script&lang=js&"
export * from "./ProfilePublicPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports